import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import PlaySvg from '../../svg/Play';
import { publicFetchMissions } from '../../services/pmissions.service';

import Mission1 from '../../screens2/primary_student/new4tasks/Mission1';
import Mission2 from '../../screens2/primary_student/new4tasks/Mission2';
import Mission3 from '../../screens2/primary_student/new4tasks/Mission3';
import Mission4 from '../../screens2/primary_student/new4tasks/Mission4';

const TASKS = [
  {
    id: 1,
    photo: '/閱讀策略/1.png',
    name: '策略1：找有關的顯性訊息',
    subtitle: '閱讀策略 1'
  },
  {
    id: 2,
    photo: '/閱讀策略/2.png',
    name: '策略2：推論超連結是否有用',
    subtitle: '閱讀策略 2'
  },
  {
    id: 3,
    photo: '/閱讀策略/3.png',
    name: '策略3：歸納來自相同或不同網頁的訊息',
    subtitle: '閱讀策略 3'
  },
  {
    id: 4,
    photo: '/閱讀策略/4.png',
    name: '策略4：判定網站上訊息是否可靠',
    subtitle: '閱讀策略 4'
  }
]

function Component(props) {
  const {  } = useParams();
  const navigate = useNavigate();
  const [data,setdata] = useState(null)
  const [isLoading,setisLoading]=useState(false)
  const [mission, setMission] = useState(null)


  const fetchData=async(force=false)=>{
    if(isLoading&&!force)return
    setisLoading(true)
    let result = await publicFetchMissions({status:'啟動中'},{limit:99});
    if(result.result){
        setdata(result.result)
    }else{
    }
    setisLoading(false)
  }

  useEffect(()=>{
    fetchData();
  },[])

  const isMobile=window.innerWidth<1024

  


  if (mission?.id === 1)
    return (
      <Mission1 onClose={() => setMission(null)} />
    )
  if (mission?.id === 2)
    return (
      <Mission2 onClose={() => setMission(null)} />
    )
  if (mission?.id === 3)
    return (
      <Mission3 onClose={() => setMission(null)} />
    )
  if (mission?.id === 4)
    return (
      <Mission4 onClose={() => setMission(null)} />
    )


  return (
    <div className='flex-[1] flex flex-col h-full' style={{overflowY:"auto",gap:isMobile?'8px':'16px',padding:isMobile?'8px':'16px'}}>

        {/*Back button */}
        <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
          <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate('/edb1/primary') }}>{`<`} 返回</div>
        </div>

        {/* <div className='text-[#43528A]' style={{fontSize:isMobile?'14px':'18px'}}>
          最新閲讀任務
        </div> */}

        <div className='flex flex-row gap-[16px] w-full flex-wrap' style={{}}>
         
          {TASKS?.map((item, index) =>
          <div key={item?._id || index} className='rounded-[20px] bg-[white] flex flex-col cursor-pointer hover:opacity-[.8]' style={{
            overflow: 'hidden', height: isMobile ? 300 / 3 * 2 : 300, width: isMobile ? 550 / 3 * 2 : 550,
          }}
            onClick={() => {
              setMission(item)
            }}>
            <img src={item?.photo} className='w-full rounded-[20px]' style={{ height: isMobile ? 205 / 3 * 2 : 205, objectFit: 'cover' }} />
            <div className='flex flex-row w-full'>
              <div className='flex flex-col flex-1'>
                <div className='flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{ paddingLeft: isMobile ? 8 : 16, paddingRight: isMobile ? 8 : 16, gap: isMobile ? 4 : 16, paddingTop: isMobile ? 2 : 8 }}>
                  <div className='text-[#43528A] font-[700]' style={{ fontSize: isMobile ? 14 : 24 }}>{item?.name}</div>
                </div>
                <div className='mt-[2px] flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{ paddingLeft: isMobile ? 8 : 16, paddingRight: isMobile ? 4 : 16, gap: isMobile ? 8 : 16 }}>
                  <div className='' style={{ fontSize: isMobile ? 12 : 18 }}>{item.subtitle}</div>
                </div>
              </div>
              <div className='h-full flex flex-row items-center' style={{ padding: isMobile ? 4 : 16 }}>
                <PlaySvg width={isMobile ? 28 : 44} />
              </div>
            </div>
          </div>
        )}
         {data?.map((item,index)=>
            <div key={item?._id||index} className='rounded-[20px] bg-[white] flex flex-col cursor-pointer hover:opacity-[.8]' style={{overflow:'hidden',height:isMobile?300/3*2:300,width:isMobile?550/3*2:550}} onClick={()=>{navigate(`/edb1/pmissions/${item?._id}`)}}>
              {item?.photo?<img src={item?.photo} className='w-full rounded-[20px]' style={{height:isMobile?205/3*2:205,objectFit:'cover'}}/>:<div className='w-full h-[205px] bg-[#999] rounded-[20px]'/>}
              <div className='flex flex-row w-full'>
                <div className='flex flex-col flex-1'>
                  <div className='flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{paddingLeft:isMobile?8:16,paddingRight:isMobile?8:16,gap:isMobile?4:16,paddingTop:isMobile?2:8}}>
                    <div className='text-[#43528A] font-[700]' style={{fontSize:isMobile?14:24}}>{item?.name}</div>
                    <div className='text-[#43528A]' style={{fontSize:isMobile?12:18}}>時間: {item?.time} 分鐘</div>
                  </div>
                  <div className='mt-[2px] flex flex-row w-full items-end text-[#43528A] flex-wrap'  style={{paddingLeft:isMobile?8:16,paddingRight:isMobile?4:16,gap:isMobile?8:16}}>
                    <div className='' style={{fontSize:isMobile?12:18}}>{item?.mission||''}</div>
                  </div>
                </div>
                <div className='h-full flex flex-row items-center' style={{padding:isMobile?4:16}}>
                  <PlaySvg width={isMobile?28:44}/>
                </div>
              </div>
            </div>
          )}
        </div>
        {/*end of missions*/}

        {isLoading&&<LoadingPage/>}
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  